/* Artemis - shared Alpine stores + behaviors. Loaded deferred after alpine.min.js.
   Registers on alpine:init so load order does not matter. */
(function () {
  /* Same-origin fetch URL helper. On the theme PREVIEW the myshopify domain 301-redirects to the
     primary domain (www.safetygear.com) unless _fd=0 is present; a fetch then follows the redirect
     cross-origin and fails (CORS, especially for requests carrying custom headers like the FBT recs).
     Carrying the current page's preview/session params keeps every theme fetch same-origin and 200.
     On the live storefront these params are absent, so this is a no-op. Use for ALL relative fetches.
     Canonically defined by a synchronous inline script in theme.liquid <head> (so it exists before any
     deferred/idle caller); this is a fallback that only defines it if that inline script is absent. */
  window.aUrl = window.aUrl || function (path) {
    try {
      var u = new URL(path, location.origin);
      if (u.origin !== location.origin) return path;
      var cur = new URLSearchParams(location.search);
      ['preview_theme_id', '_fd', 'pb'].forEach(function (k) {
        if (cur.has(k) && !u.searchParams.has(k)) u.searchParams.set(k, cur.get(k));
      });
      return u.pathname + u.search + u.hash;
    } catch (e) { return path; }
  };

  /* Shared money formatter: respects the shop's money_format so JS prices (quick-add, etc.)
     match the Liquid | money filter instead of a hardcoded "$0.00". cents -> formatted string. */
  window.aMoney = function (cents) {
    var format = window.SG_MONEY_FORMAT || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      if (number == null || isNaN(number)) { number = 0; }
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
      var rest = parts[1] ? (decimal || '.') + parts[1] : '';
      return dollars + rest;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };
  document.addEventListener('alpine:init', function () {

    /* global UI state: one open surface at a time (drawers/menus) */
    Alpine.store('ui', {
      menu: false,        // mobile nav drawer
      cart: false,        // cart drawer
      search: false,      // predictive search
      mega: null,         // open mega-menu key (desktop)
      _searchClosedAt: 0, // guards the focusin launcher against x-trap's focus-restore reopening search
      megaTimer: null,   // grace-period close for the desktop mega panels
      b2b: false,        // desktop "For business" procurement disclosure
      b2bTimer: null,
      openCart() { this._only('cart'); },
      openMenu() { this._only('menu'); },
      // open instantly (cancelling any pending close, so travel between adjacent items does not flicker);
      // close on a ~160ms delay so diagonal travel toward the far promo column does not slam it shut.
      openMega(i) { clearTimeout(this.megaTimer); this.b2b = false; this.mega = i; },
      closeMega() { clearTimeout(this.megaTimer); this.megaTimer = setTimeout(() => { this.mega = null; }, 160); },
      // the For-business disclosure shares the same grace-close behavior; opening it closes any mega
      openB2b() { clearTimeout(this.b2bTimer); this.mega = null; this.b2b = true; },
      closeB2b() { clearTimeout(this.b2bTimer); this.b2bTimer = setTimeout(() => { this.b2b = false; }, 160); },
      openSearch() { this._only('search'); this.$nextSearchFocus(); },
      closeAll() {
        const wasSearch = this.search;
        this.menu = this.cart = this.search = false; this.mega = null; this._scroll(true);
        // on Escape, x-trap restores focus to the launcher bar, whose focusin would immediately
        // reopen the drawer (a keyboard trap). Stamp the close so the launcher skips that one event.
        if (wasSearch) this._searchClosedAt = Date.now();
      },
      _only(k) { ['menu', 'cart', 'search'].forEach((x) => (this[x] = x === k)); this.mega = null; this._scroll(false); },
      // Single scroll-lock authority for the store-driven surfaces (cart/menu/search). The drawers use
      // plain x-trap (focus only), NOT x-trap.noscroll - two scroll locks fought here: on close the
      // trap restored the overflow it captured at open ('hidden'), slamming the lock back on after
      // _scroll(true) cleared it, leaving the page unscrollable until a refresh. Compensate the
      // scrollbar gutter so locking doesn't shift the layout.
      _scroll(enable) {
        const el = document.documentElement;
        if (enable) {
          el.style.overflow = '';
          el.style.paddingRight = '';
        } else {
          const sw = window.innerWidth - el.clientWidth;
          if (sw > 0) el.style.paddingRight = sw + 'px';
          el.style.overflow = 'hidden';
        }
      },
      $nextSearchFocus() {
        requestAnimationFrame(() => {
          const el = document.querySelector('[data-search-input]');
          if (el) el.focus();
        });
      }
    });

    /* sticky-on-scroll-up header: reveal pinned on scroll up, retract on scroll down,
       dispatch close-menus on retract so dropdowns close. */
    Alpine.data('aHeader', function () {
      return {
        pinned: true,
        lastY: 0,
        init() {
          this.lastY = window.scrollY;
          let ticking = false;
          const update = () => {
            const y = window.scrollY;
            if (y > this.lastY && y > 120) {
              if (this.pinned) { this.pinned = false; this.$dispatch('close-menus'); Alpine.store('ui').mega = null; }
            } else if (y < this.lastY) {
              if (!this.pinned) this.pinned = true;
            }
            this.lastY = y;
            ticking = false;
          };
          // coalesce scroll events to one update per frame
          window.addEventListener('scroll', () => {
            if (!ticking) { ticking = true; requestAnimationFrame(update); }
          }, { passive: true });
        }
      };
    });

    /* quick-add: fetch a product, pick a variant, add - without leaving the grid (the #1 funnel fix) */
    Alpine.data('aQuickAdd', function () {
      return {
        open: false, loading: false, product: null, selected: [], qty: 1, adding: false,
        sizeMode: false, runQtys: {},   // size-run shortcut: a qty per size, posted multi-line
        async load(handle) {
          this.open = true; this.loading = true; this.product = null; this.qty = 1;
          this.sizeMode = false; this.runQtys = {};
          try {
            const base_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            const r = await fetch(window.aUrl(`${base_url}products/${handle}.js`));
            this.product = await r.json();
            const base = this.product.variants.find((v) => v.available) || this.product.variants[0];
            this.selected = (this.product.options || []).map((o, i) => base.options[i]);
          } catch (e) { if (window.aToast) window.aToast('Could not load product', 'err'); this.open = false; }
          this.loading = false;
        },
        get hasOptions() { return this.product && !(this.product.options.length === 1 && this.product.options[0].name === 'Title'); },
        get current() {
          if (!this.product) return null;
          return this.product.variants.find((v) => this.selected.every((val, i) => v.options[i] === val)) || null;
        },
        get available() { return this.current && this.current.available; },
        // The picture has to follow the choice. The modal showed product.featured_image whatever was
        // selected, so on the LIFT DAX picking Black left a white hat on screen, which is the one
        // thing a colour picker must never do. Every one of that product's twelve variants carries
        // its own image, so the data was always there and simply was not read.
        // Falls back to the product image, because a variant without its own photo is normal and is
        // better served by the product shot than by an empty frame.
        get heroImage() {
          var v = this.current;
          if (v && v.featured_image && v.featured_image.src) return v.featured_image.src;
          return this.product ? this.product.featured_image : '';
        },
        get heroAlt() {
          var v = this.current;
          if (v && v.featured_image && v.featured_image.alt) return v.featured_image.alt;
          if (v && this.product) return this.product.title + ', ' + v.title;
          return this.product ? this.product.title : '';
        },
        // Is there ANY purchasable variant if the buyer picks this value, holding their other
        // choices fixed? The modal listed every size at full strength, so on the PowerWelt boot all
        // thirteen looked buyable and choosing one produced a dead "Out of stock" button. The value
        // is judged against the OTHER selections rather than on its own, so switching width can
        // legitimately bring a size back.
        valueAvailable(oi, val) {
          if (!this.product) return true;
          var self = this;
          return this.product.variants.some(function (v) {
            if (v.options[oi] !== val) return false;
            return self.selected.every(function (sel, i) { return i === oi || v.options[i] === sel; })
              && v.available;
          });
        },
        money(c) { return window.aMoney(c); },
        close() { this.open = false; },
        async add() {
          if (!this.available) return;
          this.adding = true;
          try { await window.aAddToCart({ items: [{ id: this.current.id, quantity: this.qty }] }); this.open = false; }
          catch (e) {} finally { this.adding = false; }
        },
        // ---- size-run shortcut (crew orders): a qty per size value, posted as one multi-line add,
        // the same contract the PDP size-matrix uses. Only offered when the product has a Size option.
        get sizeOptIdx() { if (!this.product) return -1; return (this.product.options || []).findIndex((o) => /size/i.test(o.name)); },
        get isSized() { return this.sizeOptIdx >= 0 && !!this.product && this.product.variants.length > 1; },
        get sizeVals() { if (!this.isSized) return []; var opt = this.product.options[this.sizeOptIdx]; return (opt && opt.values) ? opt.values : []; },
        // variant matching a given size value AND the currently-selected non-size options (width/color)
        variantForSize(sizeVal) {
          if (!this.product) return null;
          var idx = this.sizeOptIdx, self = this;
          return this.product.variants.find(function (v) {
            return v.options[idx] === sizeVal && self.selected.every(function (s, i) { return i === idx || v.options[i] === s; });
          }) || null;
        },
        get runTotal() {
          var t = 0, self = this;
          this.sizeVals.forEach(function (sv) { var v = self.variantForSize(sv); if (v) t += (parseInt(self.runQtys[v.id]) || 0); });
          return t;
        },
        async addRun() {
          var items = [], self = this;
          this.sizeVals.forEach(function (sv) {
            var v = self.variantForSize(sv);
            if (v && v.available) { var q = parseInt(self.runQtys[v.id]) || 0; if (q > 0) items.push({ id: v.id, quantity: q }); }
          });
          if (!items.length) { if (window.aToast) window.aToast(window.aT ? window.aT('matrix_need_qty') : 'Enter a quantity for at least one size', 'err'); return; }
          this.adding = true;
          try { await window.aAddToCart({ items: items }); this.open = false; } catch (e) {} finally { this.adding = false; }
        }
      };
    });

    /* cart drawer: loads /cart and refreshes via the Section Rendering API. Line qty/remove
       edit in place via /cart/change.js (returns the re-rendered cart-drawer section). */
    Alpine.data('aCart', function () {
      return {
        loading: false,
        busy: false,        // a change request is in flight (serializes drawer writes)
        pending: null,      // line key currently dimmed - set only once a write passes the 150ms threshold
        pendingQty: {},     // key -> optimistic, coalesced target quantity
        _timers: {},        // key -> debounce timeout id
        _dim: {},           // key -> dim-delay timeout id
        _fails: {},         // key -> consecutive failed commits (drives the retry backoff)
        note: '',
        noteOpen: false,
        noteSaved: false,
        _root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; },
        async saveNote() {
          try {
            await fetch(window.aUrl(`${this._root()}cart/update.js`), {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: this.note })
            });
            this.noteSaved = true;
            setTimeout(() => { this.noteSaved = false; }, 2200);
          } catch (e) { /* preview-only fetch failure */ }
        },
        // key can contain ':' and other CSS-selector-hostile chars, so scan by attribute value.
        _line(key) {
          let out = null;
          this.$root.querySelectorAll('[data-key]').forEach((el) => { if (el.getAttribute('data-key') === key) out = el; });
          return out;
        },
        _swap(htmlString) {
          const next = new DOMParser().parseFromString(htmlString, 'text/html').querySelector('[data-cart-body]');
          const here = this.$root.querySelector('[data-cart-body]');
          if (next && here) here.innerHTML = next.innerHTML;
        },
        async refresh() {
          this.loading = true;
          try {
            const res = await fetch(window.aUrl(`${this._root()}cart?section_id=cart-drawer`));
            this._swap(await res.text());
          } catch (e) { /* preview CORS on /cart is an artifact, not a bug */ }
          this.loading = false;
        },
        // +/- stepper: coalesce a burst of clicks into ONE request. Base off the optimistic pending
        // qty when present so rapid clicks accumulate instead of each re-reading the stale server
        // value baked into the button at render time.
        step(key, current, delta) {
          const base = this.pendingQty[key] != null ? this.pendingQty[key] : current;
          this.queue(key, Math.max(0, base + delta), 300);
        },
        // typed-qty entry and remove are discrete, deliberate actions: commit right away.
        change(key, qty) { this.queue(key, Math.max(0, qty), 0); },
        // Subscribe & Save on a cart line. Not routed through queue/_commit: those coalesce QUANTITY
        // and a plan change is a different axis, so debouncing them together would let a stale qty
        // write clobber the plan. Changing the plan re-keys the line in Shopify's cart, so the
        // response section is swapped in whole rather than patched.
        async setPlan(key, planId, qty) {
          if (this.busy) return;
          this.busy = true;
          const dim = setTimeout(() => { this.pending = key; }, 150);
          try {
            const res = await fetch(window.aUrl(`${this._root()}cart/change.js`), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: key, quantity: qty, selling_plan: planId ? Number(planId) : null,
                sections: 'cart-drawer', sections_url: this._root() + 'cart'
              })
            });
            const data = await res.json();
            if (!res.ok) {
              if (window.aToast) window.aToast((data && data.description) || 'Could not update this item.', 'err');
              this.refresh();
              return;
            }
            if (data.sections && data.sections['cart-drawer']) this._swap(data.sections['cart-drawer']);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count, source: 'cart-drawer' } }));
          } catch (e) { /* preview-only fetch failure */ }
          finally { clearTimeout(dim); this.busy = false; this.pending = null; }
        },
        queue(key, qty, wait) {
          this.pendingQty[key] = qty;
          const line = this._line(key);
          if (line) {
            const input = line.querySelector('.a-qty-stepper__input');
            if (input && document.activeElement !== input) input.value = qty; // optimistic; don't fight a typing user
          }
          if (this._timers[key]) clearTimeout(this._timers[key]);
          this._timers[key] = setTimeout(() => this._commit(key), wait);
        },
        async _commit(key) {
          delete this._timers[key];
          if (this.busy) { this._timers[key] = setTimeout(() => this._commit(key), 120); return; } // serialize writes
          const qty = this.pendingQty[key];
          if (qty == null) return;
          this.busy = true;
          const dim = setTimeout(() => { this.pending = key; }, 150); // only dim if the write is slow enough to notice
          this._dim[key] = dim;
          const focus = this._focusIntent(); // remember the focused control so SR/keyboard users aren't dropped to <body>
          try {
            const res = await fetch(window.aUrl(`${this._root()}cart/change.js`), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer', sections_url: this._root() + 'cart' })
            });
            // Under a cart-app interceptor (DealEasy wraps window.fetch) or the storefront's bot
            // protection, this call can come back 409/429 or as an HTML challenge page. Parsing
            // defensively and retrying keeps the buyer's target quantity instead of silently
            // snapping the line back to the last committed value.
            let data = null;
            try { data = JSON.parse(await res.text()); } catch (e) { /* HTML challenge or empty body */ }
            if (!res.ok || !data) {
              if ((this._fails[key] = (this._fails[key] || 0) + 1) <= 2) {
                this._timers[key] = setTimeout(() => this._commit(key), 700 * this._fails[key]);
                return;
              }
              this._fails[key] = 0;
              if (window.aToast) window.aToast((data && data.description) || 'Could not update cart.', 'err');
              delete this.pendingQty[key];
              this.refresh(); // re-sync the optimistic input back to server truth (e.g. stock cap hit)
              return;
            }
            this._fails[key] = 0;
            if (this.pendingQty[key] === qty) delete this.pendingQty[key];
            if (data.sections && data.sections['cart-drawer']) this._swap(data.sections['cart-drawer']);
            this._restoreFocus(focus);
            // tell the count badge + any cart-page listener; source flag stops a redundant drawer re-fetch
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count, source: 'cart-drawer' } }));
          } catch (e) {
            // Network failure: back off before the finally-block reschedule below, or a dead
            // endpoint gets hammered in a 0ms loop (pendingQty survives, so it would re-commit
            // immediately, forever). Cap the retries the same way as the non-ok branch.
            if ((this._fails[key] = (this._fails[key] || 0) + 1) > 4) {
              this._fails[key] = 0; delete this.pendingQty[key];
            } else if (!this._timers[key]) {
              this._timers[key] = setTimeout(() => this._commit(key), 700 * this._fails[key]);
            }
          }
          finally {
            clearTimeout(this._dim[key]); delete this._dim[key];
            this.busy = false; this.pending = null;
            // a click that landed mid-flight left a newer pending qty with no scheduled commit
            if (this.pendingQty[key] != null && !this._timers[key]) this._timers[key] = setTimeout(() => this._commit(key), 0);
          }
        },
        _focusIntent() {
          const ae = document.activeElement;
          if (!ae || !this.$root.contains(ae)) return null;
          const role = ae.getAttribute && ae.getAttribute('data-qty-role');
          const lk = ae.closest && ae.closest('[data-key]');
          if (!role || !lk) return null;
          return { key: lk.getAttribute('data-key'), role: role };
        },
        _restoreFocus(f) {
          if (!f) return;
          const line = this._line(f.key);
          if (!line) return; // removed line - nothing to focus
          const el = line.querySelector('[data-qty-role="' + f.role + '"]');
          if (el) el.focus();
        }
      };
    });
  });

  /* shared cart add (global - used by PDP, reorder, suggesters). body is a JSON object or FormData.
     Refreshes the cart drawer via Section Rendering API, updates count, opens drawer, toasts. */
  var _root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };
  window.aAddToCart = async function (body) {
    var isForm = body instanceof FormData;
    var opts = { method: 'POST', headers: { Accept: 'application/json' } };
    if (isForm) { body.append('sections', 'cart-drawer'); opts.body = body; }
    else { body.sections = 'cart-drawer'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    // A dropped connection, an ad-blocker, or a 5xx/rate-limit HTML body makes fetch() or
    // res.json() throw. Previously that threw straight past the toast and every caller's empty
    // catch swallowed it, so the button just reverted with no feedback (a dead-button feel on a
    // flaky jobsite signal). Catch it, tell the buyer, and rethrow so callers still reset state.
    var res, data;
    try {
      res = await fetch(window.aUrl(_root() + 'cart/add.js'), opts);
      data = await res.json();
    } catch (e) {
      if (window.aToast) window.aToast(window.aT ? window.aT('add_error') : 'Could not add to cart. Check your connection and try again.', 'err');
      throw e;
    }
    if (!res.ok) { var m = (data && data.description) || (window.aT ? window.aT('add_error_generic') : 'Could not add to cart.'); if (window.aToast) window.aToast(m, 'err'); throw new Error(m); }
    // Swap the drawer body AND read the new item_count straight from the returned section HTML
    // (its [data-cart-count] node is already the post-add count), so we no longer serialize a
    // second /cart.js round-trip purely for the badge - that doubled the perceived add latency.
    var itemCount = null;
    if (data.sections && data.sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var countNode = doc.querySelector('[data-cart-count]');
      if (countNode) { var n = parseInt(countNode.textContent, 10); if (!isNaN(n)) itemCount = n; }
      var next = doc.querySelector('[data-cart-body]'), here = document.querySelector('.a-cart-drawer [data-cart-body]');
      if (next && here) here.innerHTML = next.innerHTML;
    }
    // Update the badge/label + bump the icon. source:'cart-drawer' stops the drawer's own
    // @cart:updated listener from firing a redundant re-fetch (we just swapped it in place); the
    // cart page's aCartPage still refreshes because it only skips its own source 'cart-page'.
    if (itemCount !== null) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: itemCount, source: 'cart-drawer' } }));
    } else {
      // Fallback only if the section was absent from the response: fetch the count WITHOUT
      // blocking the drawer open (fire-and-forget), so the badge still catches up.
      fetch(window.aUrl(_root() + 'cart.js')).then(function (r) { return r.json(); }).then(function (c) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: c.item_count } }));
      }).catch(function () {});
    }
    // On the cart page, do not pop the drawer over the page; aCartPage refreshes the page in place.
    var onCartPage = !!document.querySelector('[data-cart-root]');
    var drawerOpened = false;
    if (!onCartPage && window.Alpine && Alpine.store('ui')) { Alpine.store('ui').openCart(); drawerOpened = true; }
    // The open drawer IS the confirmation; a toast on top of it was triple feedback and it
    // painted over the drawer's Checkout button.
    if (!drawerOpened && window.aToast) window.aToast(window.aT ? window.aT('added') : 'Added to cart', 'ok');
    return data;
  };

  /* toast helper, callable from any add/notify flow. Pinned bottom-right (clears Gorgias). */
  window.aToast = function (msg, kind) {
    const region = document.getElementById('a-toasts');
    if (!region) return;
    const t = document.createElement('div');
    t.className = 'a-toast a-toast--in' + (kind ? ' a-toast--' + kind : '');
    t.setAttribute('role', 'status');
    t.textContent = msg;
    region.appendChild(t);
    // commit the entrance style, then remove it so the toast transitions IN (a bare rAF can fire
    // before the initial style is committed and skip the transition; the forced reflow guarantees it)
    void t.offsetWidth;
    t.classList.remove('a-toast--in');
    setTimeout(() => { t.classList.add('a-toast--out'); setTimeout(() => t.remove(), 250); }, 3200);
  };

  /* scroll reveal (home only): below-the-fold bands fade up once as they enter. The .a-reveal
     class is added HERE, never in markup, so a JS failure leaves everything visible, and
     already-visible bands are skipped (no LCP interference, no first-paint flash). */
  function initReveals() {
    if (!document.body.classList.contains('template-index')) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = Array.prototype.filter.call(document.querySelectorAll('main .a-section'), function (el) {
      return el.getBoundingClientRect().top > window.innerHeight * 0.9;
    });
    if (!els.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); }
      });
    }, { threshold: 0.02 });
    els.forEach(function (el) { el.classList.add('a-reveal'); io.observe(el); });
  }
  if (document.readyState !== 'loading') initReveals();
  else document.addEventListener('DOMContentLoaded', initReveals);

  /* US shipping holidays: the days the warehouse and the major ground carriers (UPS/FedEx Ground)
     are closed, so neither a "ships today/Monday" promise nor the transit-day count may fall on one.
     Computed per calendar year and cached; a holiday on a Saturday is observed the prior Friday, one
     on a Sunday the following Monday. We list only the six no-service days the ground carriers observe
     (New Year's, Memorial, Independence, Labor, Thanksgiving, Christmas); MLK/Presidents/Columbus/
     Veterans are omitted because ground service runs on them. */
  var _shipHolidays = {};
  function shipHolidaySet(year) {
    if (_shipHolidays[year]) return _shipHolidays[year];
    var set = {};
    var mark = function (d) { set[(d.getMonth() + 1) + '-' + d.getDate()] = 1; };
    var observed = function (m, d) {                       // fixed-date holiday, shifted off the weekend
      var dt = new Date(year, m - 1, d), wd = dt.getDay();
      if (wd === 6) dt.setDate(dt.getDate() - 1);
      else if (wd === 0) dt.setDate(dt.getDate() + 1);
      mark(dt);
    };
    var nthWeekday = function (m, weekday, n) {             // e.g. 1st Monday of September
      var dt = new Date(year, m - 1, 1);
      dt.setDate(1 + ((weekday - dt.getDay() + 7) % 7) + (n - 1) * 7);
      mark(dt);
    };
    var lastWeekday = function (m, weekday) {               // e.g. last Monday of May
      var dt = new Date(year, m, 0);                        // day 0 of next month = last day of month m
      dt.setDate(dt.getDate() - ((dt.getDay() - weekday + 7) % 7));
      mark(dt);
    };
    observed(1, 1);        // New Year's Day
    lastWeekday(5, 1);     // Memorial Day
    observed(7, 4);        // Independence Day
    nthWeekday(9, 1, 1);   // Labor Day
    nthWeekday(11, 4, 4);  // Thanksgiving
    observed(12, 25);      // Christmas Day
    _shipHolidays[year] = set;
    return set;
  }
  function shipDayOpen(d) {                                 // a real shipping day: weekday and not a holiday
    var wd = d.getDay();
    return wd !== 0 && wd !== 6 && !shipHolidaySet(d.getFullYear())[(d.getMonth() + 1) + '-' + d.getDate()];
  }

  /* ship promise: sharpen the static "orders by X ship same day" line against the live Eastern-Time
     clock. The ship day is today when we are before cutoff on an open day, otherwise the next open
     shipping day; weekends and federal holidays are skipped, so the promise never rests on a closed
     day. Re-checked each minute. */
  function shipPromiseTick() {
    var els = document.querySelectorAll('[data-ship-promise]');
    if (!els.length) return;
    var parts, dp;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      dp = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    } catch (e) { return; } // keep the static Liquid text
    var pv = function (src, t) { var p = src.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var hour = parseInt(pv(parts, 'hour'), 10) % 24, min = parseInt(pv(parts, 'minute'), 10);
    var today = new Date(parseInt(pv(dp, 'year'), 10), parseInt(pv(dp, 'month'), 10) - 1, parseInt(pv(dp, 'day'), 10));
    var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    els.forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      var out = el.querySelector('[data-ship-promise-text]');
      if (!cutoff || !out) return;
      var leftMin = (cutoff * 60) - (hour * 60 + min);
      // Ship day: today if it is an open shipping day and we are still before cutoff, else the next open day.
      var shipsToday = shipDayOpen(today) && leftMin > 0;
      var ship = new Date(today.getTime());
      if (!shipsToday) { do { ship.setDate(ship.getDate() + 1); } while (!shipDayOpen(ship)); }
      // Message: today (with countdown) / tomorrow / Monday / a dated weekday when a holiday shifts it.
      var msg;
      if (shipsToday) {
        var h = Math.floor(leftMin / 60), m = leftMin % 60;
        var t = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
        msg = (el.getAttribute('data-msg-today') || '').replace('%time%', t);
      } else {
        var diffDays = Math.round((ship.getTime() - today.getTime()) / 86400000);
        // Monday is checked before "tomorrow" so a weekend browser sees the concrete "ships Monday"
        // rather than "ships tomorrow" on Sunday; a holiday-shifted day falls through to a dated label.
        if (ship.getDay() === 1) msg = el.getAttribute('data-msg-monday');
        else if (diffDays === 1) msg = el.getAttribute('data-msg-tomorrow');
        else msg = (el.getAttribute('data-msg-day') || '').replace('%day%', fmt(ship));
      }
      if (msg) out.textContent = msg;
      // No arrival window. Removed 2026-08-03: a store-wide transit range cannot describe drop-ship
      // items a vendor releases after prepayment, so the date it produced was confident and wrong.
      // See snippets/ship-promise.liquid for the full reasoning before adding one back.
    });
  }
  if (document.readyState !== 'loading') shipPromiseTick();
  else document.addEventListener('DOMContentLoaded', shipPromiseTick);
  setInterval(shipPromiseTick, 60000);

  /* bfcache restore: Chrome and Safari can restore this page with a stale cart badge and drawer after
     the buyer edited /cart or bounced off checkout and pressed Back. On a persisted pageshow, re-sync
     from /cart.js. bubbles:true is load-bearing: it lets the event reach BOTH the document-level badge
     listener and the drawer's @cart:updated.window refresh, so badge, label, and drawer body resync. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(window.aUrl('/cart.js')).then(function (r) { return r.json(); }).then(function (c) {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item_count: c.item_count } }));
    }).catch(function () {});
  });

  /* header search bar: a real GET form without JS; with Alpine ready, focusing it opens the
     predictive search drawer and carries any typed text into the drawer's input (x-model syncs
     via a bubbled input event). The bar is a launcher, the drawer is the search surface. */
  document.addEventListener('focusin', function (e) {
    var bar = e.target.closest && e.target.closest('[data-header-search]');
    if (!bar || !window.Alpine || !Alpine.store('ui')) return;
    var ui = Alpine.store('ui');
    if (ui.search) return;                              // drawer already open, don't re-launch
    if (Date.now() - (ui._searchClosedAt || 0) < 500) return;  // Escape just closed it; ignore the focus-restore
    var v = bar.value;
    ui.openSearch();
    // hand the typed text to the drawer input; retry a few frames in case the drawer mounts slowly,
    // so a slow hydration does not silently drop what the buyer already typed into the launcher.
    var apply = function (attempt) {
      var real = document.querySelector('[data-search-input]');
      if (!real) { if (attempt < 3) { setTimeout(function () { apply(attempt + 1); }, 60); } return; }
      if (v) { real.value = v; real.dispatchEvent(new Event('input', { bubbles: true })); }
      bar.value = '';
    };
    requestAnimationFrame(function () { apply(0); });
  });

  /* A deliberate CLICK on the bar always means "open search," even inside the 500ms post-Escape
     window that focusin ignores. Without this, closing search with Escape (which restores focus to
     the bar) then clicking the bar again did nothing for half a second, so the predictive drawer
     opened only intermittently ("sometimes the mega box, sometimes not"). focusin fires before click
     and is swallowed by the guard; this click then opens it, and openSearch() no-ops if already open. */
  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('[data-header-search]');
    if (!bar || !window.Alpine || !Alpine.store('ui')) return;
    var ui = Alpine.store('ui');
    if (ui.search) return;
    ui.openSearch();
    var v = bar.value;
    var apply = function (attempt) {
      var real = document.querySelector('[data-search-input]');
      if (!real) { if (attempt < 3) { setTimeout(function () { apply(attempt + 1); }, 60); } return; }
      if (v) { real.value = v; real.dispatchEvent(new Event('input', { bubbles: true })); }
      bar.value = '';
    };
    requestAnimationFrame(function () { apply(0); });
  });

  /* card quick-add: intercept the CTA, open the shared quick-add modal instead of going to the PDP */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-add]');
    if (!t) return;
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('quickadd:open', { detail: { handle: t.getAttribute('data-product-handle') } }));
  });

  /* cart count badge updates + a commitment "bump" on the cart icon (moment-of-commitment feedback) */
  document.addEventListener('cart:updated', function (e) {
    const count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-label]').forEach((el) => {
      var cw = el.getAttribute('data-cart-word') || 'Cart';
      var iw = el.getAttribute('data-items-word') || 'items';
      el.textContent = count > 0 ? cw + ', ' + count + ' ' + iw : cw;
    });
    const cartBtn = document.querySelector('.a-header__cart');
    if (cartBtn) { cartBtn.classList.remove('is-bump'); void cartBtn.offsetWidth; cartBtn.classList.add('is-bump'); }
  });
})();
